import React from "react";
import { ValidatorComponent } from "react-material-ui-form-validator";
import { FormHelperText } from "@material-ui/core";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// import JoditEditor from "jodit-react";

class WysiwygValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      error,
      errorMessages,
      validators,
      requiredError,
      helperText,
      value,
      isSubmit,
      ...rest
    } = this.props;

    return (
      <>
        <Editor {...rest} />
        {isSubmit && this.errorText()}
      </>
    );
  }

  errorText() {
    const { isValid } = this.state;

    if (isValid) {
      return null;
    }

    return (
      <FormHelperText style={{ color: "red" }}>
        {this.getErrorMessage()}
      </FormHelperText>
    );
  }
}

export default WysiwygValidator;
